import React from 'react'
import Scrollspy from 'react-scrollspy'
import Scroll from './Scroll'

const Nav = (props) => (
    <nav id="nav" className={props.sticky ? 'alt' : ''}>
        <Scrollspy items={ ['our-story', 'details', 'rsvp', 'registry'] } currentClassName="is-active" offset={-300}>
            <li>
                <Scroll type="id" element="our-story">
                    <a className="nav-link" href="#">Our Story</a>
                </Scroll>
            </li>
            <li>
                <Scroll type="id" element="details">
                    <a className="nav-link" href="#">Details</a>
                </Scroll>
            </li>
            <li>
                <Scroll type="id" element="rsvp">
                    <a className="nav-link" href="#">RSVP</a>
                </Scroll>
            </li>
            <li>
                <Scroll type="id" element="registry">
                    <a className="nav-link" href="#">Registry</a>
                </Scroll>
            </li>
        </Scrollspy>
    </nav>
)

export default Nav
